package one.healthium.insights.ui.content

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.rememberTopAppBarState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.NabBarStyle
import one.healthium.insights.ui.components.ContentAppTopBar
import one.healthium.insights.ui.components.ContentRenderer
import one.healthium.ui.common.message.AlertUiMessageHandler
import one.healthium.ui.compose.components.AppLoadingScreen
import one.healthium.ui.compose.components.AppScaffold
import org.koin.compose.viewmodel.koinViewModel

interface ContentEventDelegate {
    fun onBackClicked()
    fun onActionClicked(actionModel: ActionModel)
}

@Composable
fun ContentScreen(
    modifier: Modifier = Modifier,
    contentOptions: ContentOptions,
    eventDelegate: ContentEventDelegate,
) {
    val viewModel = koinViewModel<ContentViewModel>()
    val state by viewModel.state(contentOptions).collectAsState()

    LaunchedEffect(contentOptions) {
        viewModel.onContentOpened(contentOptions)
    }

    ContentScreenContent(
        modifier = modifier,
        state = state,
        contentOptions = contentOptions,
        onBackClicked = eventDelegate::onBackClicked,
        onActionClicked = { action ->
            when (action) {
                is ActionModel.Favorite -> viewModel.onFavoriteClicked(action)
                is ActionModel.Share -> Unit // TODO
                else -> eventDelegate.onActionClicked(action)
            }
        },
    )

    AlertUiMessageHandler(
        uiMessageManager = viewModel.messages,
        onMessageHandled = eventDelegate::onBackClicked
    )
}

@Composable
private fun ContentScreenContent(
    modifier: Modifier = Modifier,
    state: ContentUiState,
    contentOptions: ContentOptions,
    onBackClicked: () -> Unit,
    onActionClicked: (ActionModel) -> Unit,
) {
    val topAppBarState = rememberTopAppBarState()
    val scrollBehavior = when (state.content?.navbar?.style) {
        NabBarStyle.Large -> TopAppBarDefaults.exitUntilCollapsedScrollBehavior(
            state = topAppBarState,
            snapAnimationSpec = null,
        )

        else -> TopAppBarDefaults.pinnedScrollBehavior(topAppBarState)
    }

    AppScaffold(
        modifier = modifier.testTag("content_screen"),
        topBar = {
            ContentAppTopBar(
                model = state.navBar,
                onBackClicked = onBackClicked,
                scrollBehavior = scrollBehavior,
                state = topAppBarState,
                onActionClicked = onActionClicked,
            )
        }
    ) {
        if (state.content != null) {
            ContentRenderer(
                modifier = Modifier.padding(it).nestedScroll(scrollBehavior.nestedScrollConnection),
                content = state.content.content,
                onActionClicked = onActionClicked,
                contentPadding = PaddingValues(bottom = 160.dp),
                isMetrics = state.isMetrics,
//                    persisScrollPosition = contentOptions is ContentOptions.MealPlan,
//                    persisKey = (contentOptions as? ContentOptions.MealPlan)?.id,
            )
        }
    }
    AppLoadingScreen(visible = state.loading, dim = state.content != null)
}
